module.exports = __webpack_public_path__ + "img/card-frecuente-web-promocion@2x.e889e214.png";